/* eslint-disable */
import React, { useState, useEffect,  useContext } from 'react';
import './dealRoleMaster.scss';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import ControlledSwitches from '../../Components/Switch/switch';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import UseAxios from '../../Api/http/http';
import { dealRoleList, enableOrDisabledealRole } from '../../Api/request/roleMaster';
import {
  ENABLE_DISABLE_DEALSTATUS_DLG,
  MASTER_ROLE,
  MASTER_ROLE_FIELD,
  MASTER_ROLE_HEADERNAME,
  CANNOT_DISABLE_DEAL_ROLE_DLG
} from '../../Constants/strings';
import { AuthContext } from '../../Contexts/AuthContext';
import { useSnackbar } from '../../Components/Snackbar/snackBarProvider';
import { STATUS_CODES } from '../../Api/resources/statusCodes';
import { MODULE_NAMES } from '../../Constants/modules';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';


const DealRoleMaster = () => {
  const [rows, setRows] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_ROLE] || []
    : [];

    const hasAccess = (action) => {
      return permission.includes(action);
    };
  

  const getRolesData = () => {
    setIsLoading(true);
    UseAxios(dealRoleList())
      .then((response) => {
        // Convert the object with numeric keys to an array
        let roles = Object.values(response.data.roleDetails);
        roles = roles.map((role) => ({
          ...role,
          id: role.roleId,
          isActive: !!role.isActive,
        }));
        setRows(roles);
        setIsLoading(false);
      })
      .catch(() => {
        setRows([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRolesData();

    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);
  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [rows]);
  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
  };


  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleSwitchChange = async (rowToToggle) => {
    const updatedActiveStatus = !rowToToggle.isActive;
    const dealRoleData = {
      role_id: rowToToggle.id,
      is_active: updatedActiveStatus ? 1 : 0,
      updated_at: new Date().toISOString(),
      last_updated_by: "admin"
    };

    try {
      let response = await UseAxios(enableOrDisabledealRole(dealRoleData));
      if (response.data.status === STATUS_CODES.SUCCESS) {
        const updatedRows = rows.map((row) => {
          if (row.id === dealRoleData.role_id) {
            return {
              ...row,
              isActive: updatedActiveStatus ? 1 : 0,
            };
          }
          return row;
        });

        setRows(updatedRows);
        setIsEdit(true);
      } else if (response.data.response.status === STATUS_CODES.INVALID_REQUEST) {
          snackbarOpen(CANNOT_DISABLE_DEAL_ROLE_DLG.CANNOT_DISABLE, 'warning');
        }
    } catch (error) {
      snackbarOpen(ENABLE_DISABLE_DEALSTATUS_DLG.OOPS_TRY_AGAIN, 'warning');
    }
  };

  const filteredRows
  = searchText.length >= 1
    ? rows.filter((row) => {
      return (
        row?.roleName?.toLowerCase().includes(searchText)
        || row?.description?.toLowerCase().includes(searchText)
      );
    })
    : rows;


  const desktopColumns = [
    {
      field: MASTER_ROLE_FIELD.ROLE_NAME,
      headerName: MASTER_ROLE_HEADERNAME.ROLE_NAME,
      headerClassName: 'role-name-column',
      cellClassName: 'role-name-cell',
      flex: 0.25,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: MASTER_ROLE_FIELD.DESCRIPTION,
      headerName: MASTER_ROLE_HEADERNAME.DESCRIPTION,
      headerClassName: 'description-column',
      cellClassName: 'description-cell',
      flex: 0.59,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: MASTER_ROLE_FIELD.IS_ACTIVE,
      headerName: MASTER_ROLE_HEADERNAME.ENABLE_DISABLE,
      headerClassName: 'enable-disable-column',
      cellClassName: 'enable-disable-cell',
      flex: 0.2,
      renderCell: (params) => (
        <ControlledSwitches
        disabled={!hasAccess('update')}
        style={{ cursor: hasAccess('update') ? 'pointer' : 'not-allowed' }}
         checked={params.value}
          handleChange={() => {
            handleSwitchChange(params.row);
          }}
          inputProps={{ 'aria-label': 'enable/disable' }}
          switchCss="switchCss"
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const mobileColumns = [
    {
      field: MASTER_ROLE_FIELD.ROLE_NAME,
      headerName: MASTER_ROLE_HEADERNAME.ROLE_NAME,
      headerClassName: 'role-name-column',
      cellClassName: 'role-name-cell',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: MASTER_ROLE_FIELD.DESCRIPTION,
      headerName: MASTER_ROLE_HEADERNAME.DESCRIPTION,
      headerClassName: 'description-column',
      cellClassName: 'description-cell',
      width: 180,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: MASTER_ROLE_FIELD.IS_ACTIVE,
      headerName: MASTER_ROLE_HEADERNAME.ENABLE_DISABLE,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: 250,
      renderCell: (params) => (
        <ControlledSwitches
        disabled={!hasAccess('update')}
        style={{ cursor: hasAccess('update') ? 'pointer' : 'not-allowed' }}
          checked={params.value}
          handleChange={() => {
            handleSwitchChange(params.row);
          }}
          inputProps={{ 'aria-label': 'enable/disable' }}
          switchCss="switchCss"
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const columns = window.innerWidth <= 768 ? mobileColumns : desktopColumns;
  const sortFilterColumns = [columns[0].field, columns[1].field, columns[2].field];
  return (
    <div className="deal-role-master-outer-layer">
      <div className="deal-role-master">
        <div className="deal-role-master-title">{MASTER_ROLE}</div>
        <div className="deal-role-search-and-buttons">
          <div className="deal-role-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="role-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="deal-data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={isMobileView ? mobileColumns : desktopColumns}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isFilteredRows={filteredRows}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DealRoleMaster;
